import { INVENTARIO_CARGA } from '../actions/types';

const initialState = {
    productos: [],
    status: 'inactivo',
    error: null,
    pendingChanges: {
        byId: {},
        allIds: []
    }
};

export default function inventarioCargaReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case INVENTARIO_CARGA.LISTADO_CARGANDO:
            return {
                ...state,
                status: 'cargando',
                error: null
            };

        case INVENTARIO_CARGA.LISTADO_CARGADO:
            return {
                ...state,
                productos: payload || [],
                status: 'listo'
            };

        case INVENTARIO_CARGA.LISTADO_ERROR:
            return {
                ...state,
                status: 'error',
                error: payload || null
            };

        case INVENTARIO_CARGA.GUARDANDO:
            return {
                ...state,
                error: null
            };

        case INVENTARIO_CARGA.GUARDADO_OK:
            return {
                ...state
            };

        case INVENTARIO_CARGA.GUARDADO_ERROR:
            return {
                ...state,
                error: payload || null
            };

        case INVENTARIO_CARGA.PENDIENTE_AGREGAR:
            return {
                ...state,
                pendingChanges: {
                    byId: {
                        ...state.pendingChanges.byId,
                        [payload.tempId]: payload
                    },
                    allIds: [...state.pendingChanges.allIds, payload.tempId]
                }
            };

        case INVENTARIO_CARGA.PENDIENTE_ACTUALIZAR: {
            const pendienteActual = state.pendingChanges.byId[payload.tempId];

            if (!pendienteActual) {
                return state;
            }

            return {
                ...state,
                pendingChanges: {
                    ...state.pendingChanges,
                    byId: {
                        ...state.pendingChanges.byId,
                        [payload.tempId]: {
                            ...pendienteActual,
                            ...payload.cambios
                        }
                    }
                }
            };
        }

        case INVENTARIO_CARGA.PENDIENTE_QUITAR: {
            const byId = { ...state.pendingChanges.byId };
            delete byId[payload];

            return {
                ...state,
                pendingChanges: {
                    byId,
                    allIds: state.pendingChanges.allIds.filter((tempId) => tempId !== payload)
                }
            };
        }

        case INVENTARIO_CARGA.PENDIENTES_LIMPIAR:
            return {
                ...state,
                pendingChanges: {
                    byId: {},
                    allIds: []
                }
            };

        default:
            return state;
    }
}
